import { FunctionComponent, useRef, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import InputLabel  from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import { InfoBox } from 'components/common/InfoBox';

export class TextBoxProps {
  value: any;
  onChange?: any;
  onBlur?: any;
  helpText?: string;
  label?: any;
  icon?: any;
  name: string;
  error?: string;
  ref?: any;
  type?: string;
  focused?: boolean;
  onFocus?: any;
  disabled?: boolean;
  maxLength?: number;
  infoBox?: string;
}

export const TextBox: FunctionComponent<TextBoxProps> = ({ value, onChange, onBlur, helpText, label, icon, name, error, ref, type, focused, disabled, maxLength, onFocus, infoBox }) => {

  const inputRef = useRef<HTMLInputElement>();

  useEffect(() => {
    if (focused) {
      inputRef.current.focus();
      setTimeout(() => {
        inputRef.current.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'center' 
        });
      }, 200);
    }
  }, [focused]);

  return (<>
    {(label || infoBox) ? (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {label ? <InputLabel sx={{ fontSize: 15, fontWeight: 600, whiteSpace: 'normal' }}>{label}</InputLabel> : <></>}
        {infoBox ? <InfoBox helpText={infoBox} style={{ marginLeft: 4 }} /> : <></>}
      </div>
    ) : <></>}
    <TextField required
      error={error?true:false}
      name={name}
      type={type?type:"text"}
      disabled={disabled}
      fullWidth
      ref={ref}
      inputRef={inputRef}
      inputProps={{
        maxLength: {maxLength}
      }}
      InputProps={{
        startAdornment: icon?(
          <InputAdornment position="start">
            {icon}
          </InputAdornment>
        ):<></>
      }}
      sx={{ mx: 0, mt: "2px", mb: error?"7px":"32px" }}
      value={value}
      helperText={error}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}>
    </TextField>
  </>)
}
